<template>
  <div class="register">
    <el-form
      :model="ruleForm"
      ref="ruleForm"
      label-width="80px"
      class="register_form"
    >
      <el-form-item label="用户类型" prop="type">
        <el-radio-group  v-model="party">
          <el-radio label="1">个人用户</el-radio>
          <el-radio label="2">团队用户</el-radio>
        </el-radio-group>
        <!-- <el-radio label="6">个人用户</el-radio>
        1<el-radio label="7">团队用户</el-radio>-->
      </el-form-item>
      <el-form-item label="姓名" prop="name">
        <el-input
          v-model="ruleForm.fullName"
          placeholder="请输入姓名"
        ></el-input>
      </el-form-item>
      <el-form-item label="单位名称" prop="unit" v-if="ruleForm.type == 7">
        <el-input
          v-model="ruleForm.unit"
          placeholder="请输入单位名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="证件类型" prop="idType">
        <el-radio-group v-model="ruleForm.cardType">
          <el-radio label="0">居民身份证</el-radio>
          <el-radio label="1">护照</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="证件号码" prop="idNumber">
        <el-input
          v-model="ruleForm.cardNum"
          placeholder="请输入证件号码"
        ></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="phone">
        <el-input
          v-model="ruleForm.phone"
          maxlength="11"
          placeholder="请输入手机号"
        ></el-input>
      </el-form-item>
      <!-- <el-form-item label="验证码" class="verifyCode" prop="captcha">
        <el-input v-model="ruleForm.captcha" placeholder="请输入验证码"></el-input>
        <el-button @click="sendMessaheCode()" :disabled="disabled">{{timer.message}}</el-button>
      </el-form-item>-->
      <el-form-item>
        <el-button type="primary" class="submitBtn" @click="updateSubmit"
          >保存修改</el-button
        >
        <el-button @click="closeModal">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { sendMessaheCode, updateUserInfo, getUserInfo } from "@/libs/api";
export default {
  data() {
    var unitCheck = (rule, value, callback) => {
      if (this.ruleForm.type == "6" && value == "") {
        callback(new Error("单位名称不能为空"));
      } else {
        callback();
      }
    };
    return {
      disabled: false,
      timer: {
        time: 60,
        message: "获取验证码",
        value: "",
      },
      party: sessionStorage.getItem("party"),
      ruleForm: {},
      type: this.$store.state.accountInfo.type, //实际数据库：45 校内 67校外
    };
  },
  methods: {
    sendMessaheCode: function () {
      if (this.ruleForm.phone.length == 11) {
        sendMessaheCode(this.ruleForm.phone).then((res) => {
          if (res.status) {
            this.$message({
              message: "短信发送成功",
              type: "success",
            });
            //禁止点击按钮
            this.disabled = true;
            //定时器定时读秒
            this.timer.value = setInterval(() => {
              this.timer.time--;
              this.timer.message = "还剩" + this.timer.time + "秒";
              if (this.timer.time == 0) {
                //关闭定时器，启用按钮
                window.clearInterval(this.timer.value);
                this.timer.message = "获取验证码";
                this.disabled = false;
                this.timer.time = 60;
              }
            }, 1000);
          }
        });
      } else {
        this.$alert("请输入正确的手机号", "提示", {
          confirmButtonText: "确定",
          callback: (action) => {},
        });
      }
    },
    updateSubmit: function () {
      if (this.ruleForm.fullName.trim() == "")
        return this.$alert("姓名不能为空~");

      if (this.ruleForm.cardNum.trim() == "")
        return this.$alert("证件号码不能为空~");

      if (this.ruleForm.cardType == 0) {
        let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
        if (!reg.test(this.ruleForm.cardNum))
          return this.$alert("请输入正确的身份证号码~");
      } else if (this.ruleForm.cardType == 1) {
        let reg = /^((1[45]\d{7})|(G\d{8})|(P\d{7})|(S\d{7,8}))?$/;
        if (!reg.test(this.ruleForm.cardNum))
          return this.$alert("请输入正确的护照号码~");
      }

      if (this.ruleForm.phone.trim() == "")
        return this.$alert("手机号码不能为空~");

      if (!/^1[3456789]\d{9}$/.test(this.ruleForm.phone.trim()))
        return this.$alert("请输入正确的手机号码~");
      var party = this.party;
      let params = {
        cardNum: this.ruleForm.cardNum,
        cardType: this.ruleForm.cardType,
        headImgUrl: this.ruleForm.headImgUrl,
        fullName: this.ruleForm.fullName,
        phone: this.ruleForm.phone,
        unit: this.ruleForm.unit,
        flag:party==1?30:40  
      };
      updateUserInfo(params).then((res) => {
        if (res.status) {
          sessionStorage.setItem("userInfo", JSON.stringify(res.data.userInfoDTO));
          sessionStorage.setItem("token", res.data.token);
          sessionStorage.setItem("Admin-Token", res.data.token);
          // console.log()
          sessionStorage.setItem("party",party );
          this.$alert("修改个人资料成功。", "提示", {
            confirmButtonText: "确定",
            callback: () => {
              getUserInfo(this.$store.state.token).then((el) => {
                console.log(res);
                 sessionStorage.setItem(
                   "userInfo",
                   JSON.stringify(res.data.userInfoDTO)
                );
                this.$store.commit("updateAccountInfo", res.data.userInfoDTO);
                this.closeModal();
                this.$router.push("/");
              });
            },
          });
        } else {
          this.$alert("修改失败，" + res.message, "提示", {
            confirmButtonText: "确定",
            callback: (action) => {},
          });
        }
      });
    },
    closeModal: function (out) {
      this.$emit("close", false);
    },
  },
  created() {
    this.ruleForm = { ...JSON.parse(sessionStorage.getItem("userInfo")) };
    this.ruleForm.cardType = this.ruleForm.cardType + "";
    // console.log('用户信息：', this.ruleForm);
  },
};
</script>
<style lang="less" scoped>
.register {
  box-sizing: border-box;
  .title {
    font-size: 20px;
    height: 6vh;
    display: flex;
    align-items: center;
    padding-left: 2%;
    border-bottom: 1px solid #ccc;
    width: 95%;
    margin: 0 auto;
    box-sizing: border-box;
  }
  .register_form {
    width: 93%;
    .verifyCode {
      .el-input {
        width: 70%;
      }
      .el-button {
        background-color: #ae0c2a;
        color: white;
      }
    }
    .el-select {
      width: 100%;
    }
    .submitBtn {
      background-color: #ae0c2a;
      border: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tab/update/updateUserInfo.vue